<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="add-notification-btn">
  <button mat-fab color="primary" matTooltip="Dodaj novu obavijest" (click)="goToCreateNotification()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="notifications-container">
  @for (notification of filteredNotifications; track notification) {
    <div class="col-lg-4 col-md-6 notification-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ notification.title }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Datum objave:</strong> {{ notification.createdOn | date: 'd.M.yyyy.'  }}</p>
          <p><strong>Poruka:</strong> {{ notification.message }}</p>
          @if (notification.recipients && notification.recipients.length > 0) {
            <div class="recipients-section">
              <p><strong>Poslano udrugama:</strong></p>
              <div class="recipients-badge">
                @for (recipient of notification.recipients; track recipient) {
                  <span
                    class="recipient-badge mat-elevation-1">
                    {{ recipient.associationName }}
                  </span>
                }
              </div>
            </div>
          }
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="warn" matTooltip="Obriši obavijest" (click)="confirmDelete(notification)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
